export const cilAsterisk = ["24 24","<path d='M13.449 12l6.051-3.662v-1.723l-0.013-0.022-6.737 4.077v-7.295h-1.5v7.295l-6.737-4.077-0.013 0.022v1.723l6.051 3.662-6.051 3.662v1.723l0.013 0.022 6.737-4.077v7.295h1.5v-7.295l6.737 4.077 0.013-0.022v-1.723l-6.051-3.662z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-asterisk.js
// module id = null
// module chunks = 